import React, { useState } from "react";
import {
    Breadcrumb,
    Checkbox,
    ControlLabel,
    FormControl,
    FormGroup,
    Row,
    Col,
    Panel,
} from "react-bootstrap";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import Select from "react-select";
import { LinkContainer } from "react-router-bootstrap";
import { useModuleSettingsContext, useEventContext } from "../../../../context";
import locale from "../../../../locale";
import Information from "./Information";
import Materials from "./Materials";
import Page from "./Page";
import { positionOptions, welcomePageTimeoutOptions } from "./lib";

const PlayerSettings = () => {
    const {
        moduleBranding,
        moduleEpisode,
        moduleComment,
        moduleQuestion,
        onSaveBranding,
        onSaveEpisode,
        onSaveComment,
        onSaveQuestion,
        setPropertyBranding,
        setPropertyEpisode,
        isSaving,
    } = useModuleSettingsContext();
    const { event } = useEventContext();
    const [webAnalyticsEnabled, setWebAnalyticsEnabled] = useState(moduleBranding.yandexMetrika || false);

    const changeWebAnalyticsEnabled = (value) => {
        setWebAnalyticsEnabled(value);

        if (!value) {
            onSaveBranding({yandexMetrika: ''});
        }
    }

    return (
        <section>
            <Breadcrumb>
                <LinkContainer to={`/event/${event.eventPassword}`}>
                    <Breadcrumb.Item>{locale('mainMenu.eventSettings')}</Breadcrumb.Item>
                </LinkContainer>
                <Breadcrumb.Item active>{locale('mainMenu.eventSettings.playerSettings')}</Breadcrumb.Item>
            </Breadcrumb>
            <div style={{ display: 'flex', gap: '2rem' }}>
                <Panel style={{ flex: 1 }}>
                    <PanelHeading>
                        <PanelTitle>Общие настройки</PanelTitle>
                    </PanelHeading>
                    <PanelBody>
                        <FormGroup>
                            <Checkbox
                                checked={moduleBranding.welcomePage}
                                onChange={(e) => onSaveBranding({welcomePage: e.target.checked})}
                            >Страница приветствия</Checkbox>
                        </FormGroup>
                        <ControlLabel>Показывать обратный отсчёт до мероприятия за</ControlLabel>
                        <Row>
                            <Col xs={6}>
                                <FormGroup style={{ zIndex: 101, position: 'relative' }}>
                                    <Select
                                        value={welcomePageTimeoutOptions.find(({ value }) => moduleBranding.welcomePageTimeout === value) || welcomePageTimeoutOptions[1]}
                                        onChange={({ value }) => onSaveBranding({welcomePageTimeout: value})}
                                        options={welcomePageTimeoutOptions}
                                        isDisabled={isSaving}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <FormGroup>
                                    <Checkbox
                                        checked={moduleBranding.share}
                                        onChange={(e) => onSaveBranding({share: e.target.checked})}
                                    >Разрешить Share</Checkbox>
                                </FormGroup>
                                <FormGroup>
                                    <Checkbox
                                        checked={webAnalyticsEnabled}
                                        onChange={(e) => changeWebAnalyticsEnabled(e.target.checked)}
                                    >Включить веб-аналитику</Checkbox>
                                </FormGroup>
                            </Col>
                            <Col xs={6}>
                                <FormGroup>
                                    <Checkbox
                                        checked={moduleBranding.calendarButton}
                                        onChange={(e) => onSaveBranding({calendarButton: e.target.checked})}
                                    >Добавить в календарь</Checkbox>
                                </FormGroup>
                            </Col>
                        </Row>
                        {webAnalyticsEnabled && (
                            <>
                            <FormGroup>
                                <ControlLabel>Яндекс Метрика</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={moduleBranding.yandexMetrika}
                                    placeholder="XXXXXXXX"
                                    onChange={(e) => setPropertyBranding('yandexMetrika', e.target.value)}
                                    onBlur={() => onSaveBranding({ yandexMetrika: moduleBranding.yandexMetrika })}
                                    disabled={isSaving}
                                />
                            </FormGroup>
                            </>
                        )}
                    </PanelBody>
                </Panel>
                <Panel style={{ flex: 1 }}>
                    <PanelHeading>
                        <PanelTitle>Модули</PanelTitle>
                    </PanelHeading>
                    <PanelBody>
                        <FormGroup>
                            <ControlLabel>Эпизоды</ControlLabel>
                            <Row>
                                <Col xs={6}>
                                    <p>Расположение</p>
                                    <Select
                                        value={positionOptions.find(({ value }) => moduleEpisode.position === value) || positionOptions[2]}
                                        onChange={({ value }) => onSaveEpisode({position: value})}
                                        options={positionOptions}
                                        isDisabled={isSaving}
                                    />
                                </Col>
                                <Col xs={6}>
                                    <p>Пикселей в минуте расписания</p>
                                    <FormControl
                                        type="text"
                                        value={moduleEpisode.pixelInMinute}
                                        placeholder="По умолчанию 3"
                                        onChange={(e) => setPropertyEpisode('pixelInMinute', e.target.value)}
                                        onBlur={() => onSaveEpisode({ pixelInMinute: moduleEpisode.pixelInMinute })}
                                        disabled={isSaving}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Checkbox
                                        checked={moduleEpisode.showTable}
                                        onChange={(e) => onSaveEpisode({showTable: e.target.checked})}
                                    >Открывать записи</Checkbox>
                                </Col>
                                <Col xs={6}>
                                    <Checkbox
                                        checked={moduleEpisode.allowSingleEpisodeWatch}
                                        onChange={(e) => onSaveEpisode({allowSingleEpisodeWatch: e.target.checked})}
                                    >Разрешить встраивание эпизода</Checkbox>
                                </Col>
                            </Row>
                        </FormGroup>
                        <hr />
                        <Row>
                            <Col xs={6}>
                                <FormGroup>
                                    <ControlLabel>Чат</ControlLabel>
                                    <p>Расположение</p>
                                    <Select
                                        value={positionOptions.find(({ value }) => moduleComment.position === value) || positionOptions[1]}
                                        onChange={({ value }) => onSaveComment({position: value})}
                                        options={positionOptions.slice(1)}
                                        isDisabled={isSaving}
                                    />
                                    <Checkbox
                                        checked={moduleComment.order > 0}
                                        onChange={(e) => {onSaveComment({order: e.target.checked ? 1 : 0}); onSaveQuestion({order: 0});}}
                                    >Открывать по умолчанию</Checkbox>
                                </FormGroup>
                            </Col>
                            <Col xs={6} style={{borderLeft: '1px solid #eeeeee'}}>
                                <FormGroup>
                                    <ControlLabel>Вопросы</ControlLabel>
                                    <p>Расположение</p>
                                    <Select
                                        value={positionOptions.find(({ value }) => moduleQuestion.position === value) || positionOptions[1]}
                                        onChange={({ value }) => onSaveQuestion({position: value})}
                                        options={positionOptions.slice(1)}
                                        isDisabled={isSaving}
                                    />
                                    <Checkbox
                                        checked={moduleQuestion.order > 0}
                                        onChange={(e) => {onSaveComment({order: 0}); onSaveQuestion({order: e.target.checked ? 1 : 0});}}
                                    >Открывать по умолчанию</Checkbox>
                                </FormGroup>
                            </Col>
                        </Row>
                    </PanelBody>
                </Panel>
            </div>
            <div style={{ display: 'flex', gap: '2rem' }}>
                <Information />
            </div>
            <div style={{ display: 'flex', gap: '2rem', alignItems: 'flex-start' }}>
                <Materials />
                <Page />
            </div>
        </section>
    );
};

export default PlayerSettings;